const VISITOR_TRACKED_KEY = 'visitor_tracked';

export const visitorService = {
  async trackVisitor(page, user = null) {
    try {
      // Check if already tracked this session for this page
      const trackedPages = JSON.parse(sessionStorage.getItem(VISITOR_TRACKED_KEY) || '{}');
      if (trackedPages[page]) {
        return { status: 'already_tracked_client' };
      }

      const payload = {
        page,
        referrer: document.referrer || null,
      };

      // Add user info if logged in
      if (user) {
        payload.user_id = user.id;
        payload.user_name = user.name;
        payload.user_email = user.email;
      }

      const response = await fetch('/api/v1/visitors/track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      // Mark as tracked for this session
      trackedPages[page] = true;
      sessionStorage.setItem(VISITOR_TRACKED_KEY, JSON.stringify(trackedPages));

      return result;
    } catch (error) {
      console.error('Error tracking visitor:', error);
      return { status: 'error' };
    }
  },
};
